export default {
    methods: {
        ajaxSubmit(headers, httpMethod, url, formData) {
            return axios({
                headers: headers,
                method:  httpMethod,
                url:     url,
                data:    formData
            });
        },

        showLoader() {
            vm.loading = true;

            $('#main_spinner').css({
                opacity: '.8',
                top:     0
            }).find('.spinner-border').css('top', '45%');
        },

        hideLoader() {
            vm.loading = false;

            $('#main_spinner').css({
                opacity: 1,
                top:     'auto'
            }).find('.spinner-border').css('top', '40%');
        },

        init(){
            $('a.router-link-active').click(function(){
                return false;
            });
        },
        customClone(data) {
            return JSON.parse(JSON.stringify(data));
        },
        customCloneCircular(data) {
            return JSON.parse(JSON.stringify(data, this.getCircularReplacer()));
        },
        generateGuid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        },

        //usage: JSON.parse(JSON.stringify(some_data, this.getCircularReplacer()))
        getCircularReplacer(){
            const seen = new WeakSet();
            return (key, value) => {
                if (typeof value === "object" && value !== null) {
                    if (seen.has(value)) {
                        return;
                    }
                    seen.add(value);
                }
                return value;
            };
        },
        getUserPermissions() {
            return this.$store.getters.getAuthUser.original.permissions;
        },
        notification(message, type, title, size = BootstrapDialog.SIZE_SMALL, hideAfter = 500000, callbackHide=null) {
            if (!message) {
                return false;
            }

            type = type && BootstrapDialog.hasOwnProperty(type) ? BootstrapDialog[type] : BootstrapDialog.TYPE_SUCCESS;

            if (!title) {
                if (type === 'type-success') {
                    title = 'INFORMATION';
                } else if (type === 'type-warning') {
                    title = 'WARNING';
                } else if (type === 'type-danger') {
                    title = 'ERROR';
                }
            }

            return BootstrapDialog.show({
                title: title,
                type: type,
                message: message,
                size: size,

                onshow(dialogRef) {
                    setTimeout(() => {
                        dialogRef.close();
                    }, hideAfter);
                },
                onhide(){
                    $('body').find('.refresh-accounts').addClass('hidden');
                    if(!!callbackHide){
                        callbackHide();
                    }
                }
            });
        },
        confirmation(message, callbackOk, callbackCancel, type, title, size = BootstrapDialog.SIZE_SMALL, btnOkLabel, btnCancelLabel) {
            if (!message) {
                return false;
            }

            type = type && BootstrapDialog.hasOwnProperty(type) ? BootstrapDialog[type] : BootstrapDialog.TYPE_WARNING;
            callbackOk = callbackOk || function() {};
            callbackCancel = callbackCancel || function() {};

            BootstrapDialog.confirm({
                title: title || 'WARNING',
                type: type,
                message: message,
                btnOKLabel: btnOkLabel || 'OK',
                btnOKClass: 'btn-success',
                btnCancelLabel: btnCancelLabel || 'Cancel',
                btnCancelClass: 'btn',
                size: size || BootstrapDialog.SIZE_SMALL,

                callback(result) {
                    result ? callbackOk() : callbackCancel();
                }
            });
        },
        addThousandCommas(number){
            if(number < 1) return number;

            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        niceDecimalPlaces(number, dp, more = 0){
            if(number == 0) return dp;
            dp += more;
            if(number < Math.pow(10, -9)){
                return 9 + dp;
            }
            if(number < Math.pow(10, -8)){
                return 8 + dp;
            }
            if(number < Math.pow(10, -7)){
                return 7 + dp;
            }
            if(number < Math.pow(10, -6)){
                return 6 + dp;
            }
            if(number < Math.pow(10, -5)){
                return 5 + dp;
            }
            if(number < Math.pow(10, -4)){
                return 4 + dp;
            }
            if(number < Math.pow(10, -3)){
                return 3 + dp;
            }
            if(number < Math.pow(10, -2)){
                return 2 + dp;
            }
            if(number < Math.pow(10, -1)){
                return 1 + dp;
            }
            dp -= more;
            return dp;
        },
        niceFormat(number, dp, force_dp = false){
            if (number >= Math.pow(10, 9)){
                if(force_dp){
                    if(1000*(0.001*Math.round(number / Math.pow(10, 6))).format(dp+3) == 1000*(0.001*Math.round(number / Math.pow(10, 6))).format(dp)){
                        return (0.001*Math.round(number / Math.pow(10, 6))).format(dp) + 'G';
                    }
                    return (0.001*Math.round(number / Math.pow(10, 6))).format(dp+3) + 'G';
                }
                else{
                    return Math.round(number / Math.pow(10, 9)) + 'G ';
                }
            }
            if (number >= Math.pow(10, 6)){
                if(force_dp){
                    if(100*(0.01*Math.round(number / Math.pow(10, 4))).format(dp+2) == 100*(0.01*Math.round(number / Math.pow(10, 4))).format(dp)){
                        return (0.01*Math.round(number / Math.pow(10, 4))).format(dp) + 'M';
                    }
                    return (0.01*Math.round(number / Math.pow(10, 4))).format(dp+2) + 'M';
                }
                else{
                    return Math.round(number / Math.pow(10, 6)) + 'M ';
                }
            }
            if (number >= Math.pow(10, 3)){
                if(force_dp){
                    if(10*(0.1*Math.round(number / Math.pow(10, 2))).format(dp+1) == 10*(0.1*Math.round(number / Math.pow(10, 2))).format(dp)){
                        return (0.1*Math.round(number / Math.pow(10, 2))).format(dp) + 'k';
                    }
                    return (0.1*Math.round(number / Math.pow(10, 2))).format(dp+1) + 'k';
                }
                else{
                    return Math.round(number / Math.pow(10, 3)) + 'k';
                }
            }
            if(number < Math.pow(10, -11)){
                let ret = (number * Math.pow(10, 12)).format(dp);
                let dp_to_use = this.cleanDecimals(ret);
                return (number * Math.pow(10, 12)).format(dp_to_use) + 'p';
            }
            if(number < Math.pow(10, -10)){
                let dp_to_use = dp > 0 ? dp - 1 : dp;
                let ret = (number * Math.pow(10, 12)).format(dp_to_use);
                dp_to_use = this.cleanDecimals(ret);
                return (number * Math.pow(10, 12)).format(dp_to_use) + 'p';
            }
            if(number < Math.pow(10, -9)){
                return (number * Math.pow(10, 12)).format(0) + 'p';
            }
            if(number < Math.pow(10, -8)){
                let ret = (number * Math.pow(10, 9)).format(dp);
                let dp_to_use = this.cleanDecimals(ret);
                return (number * Math.pow(10, 9)).format(dp_to_use) + 'n';
            }
            if(number < Math.pow(10, -7)){
                let dp_to_use = dp > 0 ? dp - 1 : dp;
                let ret = (number * Math.pow(10, 9)).format(dp_to_use);
                dp_to_use = this.cleanDecimals(ret);
                return (number * Math.pow(10, 9)).format(dp_to_use) + 'n';
            }
            if(number < Math.pow(10, -6)){
                return (number * Math.pow(10, 9)).format(0) + 'n';
            }
            if(number < Math.pow(10, -5)){
                let ret = (number * Math.pow(10, 6)).format(dp);
                let dp_to_use = this.cleanDecimals(ret);
                return (number * Math.pow(10, 6)).format(dp_to_use) + 'µ';
            }
            if(number < Math.pow(10, -4)){
                let dp_to_use = dp > 0 ? dp - 1 : dp;
                let ret = (number * Math.pow(10, 6)).format(dp_to_use);
                dp_to_use = this.cleanDecimals(ret);
                return (number * Math.pow(10, 6)).format(dp_to_use) + 'µ';
            }
            if(number < Math.pow(10, -3)){
                return (number * Math.pow(10, 6)).format(0) + 'µ';
            }
            if(number < Math.pow(10, -2)){
                let ret = (number * Math.pow(10, 3)).format(dp);
                let dp_to_use = this.cleanDecimals(ret);
                return (number * Math.pow(10, 3)).format(dp_to_use) + 'm';
            }
            if(number < Math.pow(10, -1)){
                let ret = number.format(dp + 1);
                let dp_to_use = this.cleanDecimals(ret);
                return number.format(dp_to_use);
            }

            return number;
        },
        niceFormatB2B(n, dp, factor){
            let number = Math.abs(n / factor);

            if(number > Math.pow(10, 9)){
                return Math.round(number / Math.pow(10, 9)) + 'G';
            }
            if(number > Math.pow(10, 6)){
                return Math.round(number / Math.pow(10, 6)) + 'M';
            }
            if(number > Math.pow(10, 3)){
                return Math.round(number / Math.pow(10, 3)) + 'k';
            }
            if(number < Math.pow(10, -11)){
                let ret = (number * Math.pow(10, 12)).format(dp);
                let dp_to_use = this.cleanDecimals(ret);
                return (number * Math.pow(10, 12)).format(dp_to_use) + 'p';
            }
            if(number < Math.pow(10, -10)){
                let dp_to_use = dp > 0 ? dp - 1 : dp;
                let ret = (number * Math.pow(10, 12)).format(dp_to_use);
                dp_to_use = this.cleanDecimals(ret);
                return (number * Math.pow(10, 12)).format(dp_to_use) + 'p';
            }
            if(number < Math.pow(10, -9)){
                return (number * Math.pow(10, 12)).format(0) + 'p';
            }
            if(number < Math.pow(10, -8)){
                let ret = (number * Math.pow(10, 9)).format(dp);
                let dp_to_use = this.cleanDecimals(ret);
                return (number * Math.pow(10, 9)).format(dp_to_use) + 'n';
            }
            if(number < Math.pow(10, -7)){
                let dp_to_use = dp > 0 ? dp - 1 : dp;
                let ret = (number * Math.pow(10, 9)).format(dp_to_use);
                dp_to_use = this.cleanDecimals(ret);
                return (number * Math.pow(10, 9)).format(dp_to_use) + 'n';
            }
            if(number < Math.pow(10, -6)){
                return (number * Math.pow(10, 9)).format(0) + 'n';
            }
            if(number < Math.pow(10, -5)){
                let ret = (number * Math.pow(10, 6)).format(dp);
                let dp_to_use = this.cleanDecimals(ret);
                return (number * Math.pow(10, 6)).format(dp_to_use) + 'µ';
            }
            if(number < Math.pow(10, -4)){
                let dp_to_use = dp > 0 ? dp - 1 : dp;
                let ret = (number * Math.pow(10, 6)).format(dp_to_use);
                dp_to_use = this.cleanDecimals(ret);
                return (number * Math.pow(10, 6)).format(dp_to_use) + 'µ';
            }
            if(number < Math.pow(10, -3)){
                return (number * Math.pow(10, 6)).format(0) + 'µ';
            }
            if(number < Math.pow(10, -2)){
                let ret = (number * Math.pow(10, 3)).format(dp);
                let dp_to_use = this.cleanDecimals(ret);
                return (number * Math.pow(10, 3)).format(dp_to_use) + 'm';
            }
            if(number < Math.pow(10, -1)){
                let ret = number.format(dp + 1);
                let dp_to_use = this.cleanDecimals(ret);
                return number.format(dp_to_use);
            }

            return (factor != 1) ? Math.round(number) : number;
        },
        cleanDecimals(n){
            let strArr = n.toString().split('.');
            let strDec = (strArr.length > 1) ? strArr[1] : '0';

            if(parseInt(strDec) == 0) return 0;

            let len = strDec.length;
            let dec = Math.pow(10, -len)*parseInt(strDec);
            for(var i=0;i<len;i++){
                if(Math.floor(Math.pow(10, i+1)*dec) == Math.pow(10, i+1)*dec){
                    return i+1;
                }
            }
            return len;
        },
        cleanNumber(number){
            if(!!number && !$.isNumeric(number)){
                return parseFloat(number.replace(/[^\d.]+/g, ''));
            }

            return number;
        },
        checkMissedTables(elements_data){
            const tables = elements_data.tables;
            let ret = []
            _.each(tables, (table, table_idx) => {
                if((table.metrics.length == 1) && (table.metrics[0] == '_')){
                    ret[table_idx] = true;
                }
            });

            return ret;
        },
        checkAccounts(elements_data){
            const accounts = elements_data.accounts;
            const data_sources_by_id = elements_data.data_sources_by_id;
            let ret = [];
            _.each(accounts, (account, ds_id) => {
                if(!account.length){
                    ret.push(data_sources_by_id[ds_id]);
                }
            });

            return ret;
        },

        dataURLtoFile(dataurl, filename) {
            const arr    = dataurl.split(',');
            const mime   = arr[0].match(/:(.*?);/)[1];
            const base64 = atob(arr[1]);
            let length   = base64.length;
            let u8array  = new Uint8Array(length);

            while (length--) {
                u8array[length] = base64.charCodeAt(length);
            }

            return new File([u8array], filename, {type: mime});
        },
        truncateString(str, num) {
            if (str && str.length > num) {
                return str.slice(0, num) + "...";
            } else {
                return str;
            }
        }
    }
}
